import React, {Component}      from 'react'
import { Modal, Checkbox, TreeSelect, message }     from 'antd'
import css from "classnames"
import treeFlatten              from 'tree-flatten'
import flatten                  from 'lodash/flatten'
import CloudFlyerAPI              from "../../api/CloudFlyerAPI"

export default class SetFinanceAlert extends Component {

    constructor(props){
        super(props)

        this.state = {
            forecast     : 80,
            actual       : 80,

            forecast_disabled : false,
            actual_disabled   : true,

            budget_fetched : false,

            budget   : {
                cloud   : this.props.selected_cloud,
                product : this.props.selected_service,

                actual_alert_percent   : 0,
                forecast_alert_percent : 0
            },

            start_month : new Date().getMonth(),
            start_year  : new Date().getFullYear(),

            end_month   : 11,
            end_year    : new Date().getFullYear(),

            months : [
                /*{
                    label:'All months',
                    month:0
                },*/
                {
                    label:'January',
                    month:0
                },
                {
                    label:'February',
                    month:1
                },
                {
                    label:'March',
                    month:2
                },
                {
                    label:'April',
                    month:3
                },
                {
                    label:'May',
                    month:4
                },
                {
                    label:'June',
                    month:5
                },
                {
                    label:'July',
                    month:6
                },
                {
                    label:'August',
                    month:7
                },
                {
                    label:'September',
                    month:8
                },
                {
                    label:'October',
                    month:9
                },
                {
                    label:'November',
                    month:10
                },
                {
                    label:'December',
                    month:11
                }
            ],

            years : [
                {
                    label : new Date().getFullYear(),
                    year  : new Date().getFullYear()
                },
                {
                    label :new Date().getFullYear() + 1,
                    year  : new Date().getFullYear() + 1
                }
            ]
        }
    }

    componentDidMount(){}

    componentWillReceiveProps(props){
        if((!this.state.budget_fetched || props.selected_service !== this.state.selected_service) && this.props.tree.length) {
            this.setState({
                selected_service:props.selected_service
            }, ()=> this.refresh(this.props.selected_service))
        }
    }

    on_input_change = ({target}) => this.setState({[target.name]: target.value})

    on_save = () => {
        const {actual_disabled, forecast_disabled, actual, forecast, limit, limit_budget, start_month, start_year, end_month, end_year} = this.state

        let {cloud, title} = this.selected_cloud(this.props.selected_service)
        let body = {
            cloud   : cloud,
            product : title,

            actual_alert_percent   : actual_disabled  ? null  : actual,
            forecast_alert_percent : forecast_disabled ? null : forecast,

            start : new Date(start_year, start_month, 1),
            end   : new Date(end_year, end_month, 1)
        }

        CloudFlyerAPI
            .finance
            .set_alert(body)
            .then(()=> message.success('Alert saved successfully') && this.props.on_close())
            .catch(err=> message.error(((err.response || {}).data || {}).message || 'Failed to save alert please try again later'))
    }

    on_close = () => this.props.on_close()

    on_checkbox_change = (type, value) => this.setState({[type]: value})

    selected_cloud = product => {
        let record = flatten(this.props.tree.map(m => treeFlatten(m, 'children')))
            .find(d => d.value === product) || {cloud: '', title: ''}
        if(record.value && record.value.endsWith('total'))
            record.title = 'total'
        return record
    }

    refresh = product => {
         !this.state.loading && this.props.selected_service && this.setState({loading: true}, () => {
             let {cloud, title} = this.selected_cloud(product)
            CloudFlyerAPI
                .finance
                .budget(cloud, title)
                .then(({data: budget = {}}) => {
                    this.setState({
                        budget,
                        forecast_disabled: !budget.forecast_alert_percent,
                        actual_disabled: !budget.actual_alert_percent,
                        forecast: budget.forecast_alert_percent || 80,
                        actual: budget.actual_alert_percent || 80,

                        budget_fetched: true,
                        loading: false,

                        start_month: budget.start ? new Date(budget.start).getMonth() : new Date().getMonth(),
                        start_year: budget.start ? new Date(budget.start).getFullYear() : new Date().getFullYear(),

                        end_month: budget.start ? new Date(budget.end).getMonth() : 11,
                        end_year: budget.start ? new Date(budget.end).getFullYear() : (new Date().getFullYear() + 1)
                    })
                })
                .catch(()=> this.setState({budget_fetched: true, loading: false}))
        })
    }

    render() {
        const {forecast, actual, actual_disabled, forecast_disabled, months, years, start_month, end_month, start_year, end_year } = this.state
        const { selected_service, on_service_change, tree, visible}  = this.props

        return <Modal visible={visible} footer={null} onCancel={this.on_close}>
            <div className='modal-form set-finance-alert'>
                <header>
                    Set Finance Notifications
                </header>

                <section className='input-group'>
                    <label>Service</label>
                    <TreeSelect placeholder='Select service'
                                value={selected_service}
                                className='services'
                                size={'large'}
                                treeData={tree}
                                onSelect={val =>{on_service_change('selected_service', val); this.refresh(val)}}
                                treeDefaultExpandedKeys={['total']}/>
                </section>

                <section className='input-group notify'>
                    <label>Notify me if my</label>
                </section>

                <div className={'checks'}>
                    <div className={'check'}>
                        <Checkbox checked={!forecast_disabled} className={css({'disabled':forecast_disabled})}
                            onChange={e => this.on_checkbox_change('forecast_disabled', !e.target.checked)}>Forecast reaches</Checkbox>
                        <input type='number' value={forecast}
                               className={css({'input':true, 'disabled':forecast_disabled})} name='forecast'
                               onChange={this.on_input_change}/>
                        <span className={css({'disabled':forecast_disabled})}>&nbsp;&nbsp; % of budget</span>
                    </div>

                    <div className={'check'}>
                        <Checkbox checked={!actual_disabled} className={css({'disabled':actual_disabled})}
                            onChange={e => this.on_checkbox_change('actual_disabled', !e.target.checked)}>Actual reaches &nbsp;&nbsp;&nbsp;</Checkbox>
                        <input type='number' value={actual}
                               className={css({'input':true, 'disabled':actual_disabled})} name='actual'
                               onChange={this.on_input_change}/>
                        <span className={css({'disabled':actual_disabled})}>&nbsp;&nbsp; % of budget</span>
                    </div>
                </div>

                <section className='input-group months'>
                    <label>In the following months</label>
                    <div>
                        <select value={start_month} name='start_month'
                                className='input' onChange={this.on_input_change}>
                            {months.map(m => (<option key={m.month} value={m.month}>{m.label}</option>))}
                        </select>
                        <select value={start_year} name='start_year'
                                className='input' onChange={this.on_input_change}>
                            {years.map(m => (<option key={m.year} value={m.year}>{m.label}</option>))}
                        </select>

                        <span className='to-sign'>to</span>
                        <select value={end_month} name='end_month'
                                className='input' onChange={this.on_input_change}>
                            {months.map(m => (<option key={m.month} value={m.month}>{m.label}</option>))}
                        </select>
                        <select value={end_year} name='end_year'
                                className='input' onChange={this.on_input_change}>
                            {years.map(m => (<option key={m.year} value={m.year}>{m.label}</option>))}
                        </select>
                    </div>
                </section>

                <div className='button-container'>
                    <button className='btn primary' onClick={this.on_save}>
                        Create
                    </button>
                </div>
            </div>
        </Modal>
    }
}